import { render, staticRenderFns } from "./admin-separate-customers-prospects.vue?vue&type=template&id=6567b347&scoped=true&"
import script from "./admin-separate-customers-prospects.vue?vue&type=script&lang=js&"
export * from "./admin-separate-customers-prospects.vue?vue&type=script&lang=js&"
import style0 from "./admin-separate-customers-prospects.vue?vue&type=style&index=0&id=6567b347&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567b347",
  null
  
)

export default component.exports